import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

const statePaths = [
  ['authentication'],
  ['claims', 'getClaims'],
  ['claims', 'getGWClaims'],
  ['claims', 'createClaim'],
  ['claims', 'createShellClaim'],
  ['claims', 'updateClaim'],
  ['claims', 'submitClaim'],
  ['policyDetails'],
  ['services', 'uber', 'createVoucher'],
  ['services', 'enterprise', 'searchLocations'],
  ['services', 'enterprise', 'createRental'],
  ['services', 'audatarget', 'searchVendor'],
  ['services', 'audatarget', 'availability'],
  ['services', 'audatarget', 'bookAppointment'],
];

const selectError = (state) => {
  let i = 0;
  let error = fromJS({ error: false });

  do {
    const content = getStateContent(state, statePaths[i]);
    error = content.getIn(['error']) || error;

    i += 1;
  } while (i < statePaths.length && error.getIn(['error']) === false);

  return error;
};

const getStateContent = (state, path) => {
  let i = 1;
  let content = state[path[0]];

  while (i < path.length) {
    content = content.getIn([path[i]]);
    i += 1;
  }

  return content;
};

export const errorSelector = createSelector(selectError, (state) => state?.toJS());
